import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

import Modal from '../../../components/common/modal/Modal'
import DataTablePagination from '../../../components/common/datatable/DataTablePagination'
import { Loader } from '../../../components/common/Loader';
import ButtonComponent from '../../../components/common/button/Button';

export const TabModal = ({open, handleClose, title, pmSourceData, goToPage, onPageSizeChanged, loading, getRowStyle, pageSize, currentPage, totalPages, totalPageItems, totalItemCurrentPage}, props) => {
  const priceMemoModalData = useSelector(
    (state) => state?.getAllSourcePriceMemo
  );
  const [headerItems, setHeaderItems] = useState(null);
  const [disableFilterBtn, setDisableFilterBtn] = useState(true);
  const [filteredTotalItems, setFilteredTotalItems] = useState(priceMemoModalData?.data?.totalNumberOfItems);
  const [filteredTotalColumn, setFilteredTotalColumn] = useState(0);

  const handlePostFilterChanged = (filteredCount, totalCount) => {
    setFilteredTotalItems(filteredCount); // Update the filtered total items
  };

  useEffect(() => {
    priceMemoModalData?.data?.totalNumberOfItems && setFilteredTotalItems(priceMemoModalData?.data?.totalNumberOfItems)
  }, [priceMemoModalData?.data?.totalNumberOfItems])

  const renderExpandableText = (params, maxLength = 50) => {
    const text = params.value || ""; // The error details text
    const isLongText = text.length > maxLength;

    // Initialize the showFullText property for the row if not already set
    if (!params.node.showFullText) {
      params.node.showFullText = false;
    }

    const toggleText = () => {
      params.node.showFullText = !params.node.showFullText;
      params.api.refreshCells({ rowNodes: [params.node], force: true }); // Refresh the cell to update the UI
    };

    return isLongText ? (
      <div>
        {params.node.showFullText ? (
          <>
            <span>{text}</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              Less
            </button>
          </>
        ) : (
          <>
            <span>{text.substring(0, maxLength)}...</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              More
            </button>
          </>
        )}
      </div>
    ) : (
      <span>{text}</span>
    );
  };

  useEffect(() => {
    if(pmSourceData?.packagingPriceMemo) {
      setHeaderItems([
        {
          headerName: 'Plant Id',
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Vendor Number',
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'CC Material No',
          field: "ccMaterialNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Description',
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Year',
          field: "yearPckg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Location Name',
          field: "locationName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager',
          field: "managerName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Last Change',
          field: "lastChange",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Payment Description',
          field: "paymentDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Price',
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Description',
          field: "supplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Supplier Item No',
          field: "supplierItemNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Type',
          field: "materialType",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective From',
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective To',
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Payment Term',
          field: "sapPaymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          pinned: "right",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
      ])
    }
    if(pmSourceData?.agriPriceMemo) {
      setHeaderItems([
        {
          headerName: 'Plant Id',
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Vendor Number',
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Number',
          field: "materialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Description',
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'S No.',
          field: "snumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Group',
          field: "groupAgri",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sub Category',
          field: "subCategory",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Brand',
          field: "brand",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Prorement Manager',
          field: "prorementManager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Geography',
          field: "geography",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Picasso Approval',
          field: "picassoApproval",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Origin',
          field: "materialOrigin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'LeadTime',
          field: "leadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Ship From Country',
          field: "shipFromCountry",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Ship From City',
          field: "shipFromCity",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Payment Term',
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Material Cost Per UOM',
          field: "materialCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Total Cost Per UOM',
          field: "totalCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'RFA Ft Per UOM',
          field: "rfaFtPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Bid Incoterm',
          field: "bidIncoterm",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Bid Incoterm Location',
          field: "bidIncotermLocation",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price Effective Date',
          field: "priceEffectiveDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price EndDate',
          field: "priceEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Packaging Size',
          field: "packagingSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          pinned: "right",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
      ])
    }
    if(pmSourceData?.sisPriceMemo){
      setHeaderItems([
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Plant Number',
          field: "sapPlantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Id',
          field: "supplierId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Supplier Id',
          field: "sapSupplierId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Supplier Description',
          field: "sapSupplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Material Number',
          field: "sapMaterialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Material Description',
          field: "sapMaterialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Location Name',
          field: "locationName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Ingredient',
          field: "ingredient",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Package Size',
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Year',
          field: "yearSIS",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Change Date',
          field: "changeDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager Initials',
          field: "managerInitials",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager',
          field: "managerName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Group',
          field: "extMaterialGroup",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Number',
          field: "materialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Kosher PO',
          field: "kosherPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Kosher Yr',
          field: "kosherYr",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PC Initial',
          field: "pcInitial",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Id',
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PMU Date',
          field: "pmUdate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price Per Lb',
          field: "pricePerLb",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price Tag ID',
          field: "priceTagId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'SCA',
          field: "sca",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'X',
          field: "x",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PIN',
          field: "pin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Package Name',
          field: "packageName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price per Kg',
          field: "pricePerKG",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective From',
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective To',
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Payment Term',
          field: "paymentTerms",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Auto Co Ship',
          field: "autoCoship",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Allocation Quantity',
          field: "allocationQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Allocation Notes',
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          pinned: "right",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
      ])
    } if (pmSourceData?.cepgPriceMemo) {
      const cepgHeader = [
        {
          headerName: 'Plant Id',
          field: "plant",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Number',
          field: "material",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
        },
        {
          headerName: 'Material Description',
          field: "description",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Package Size',
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'S-Code',
          field: "scode",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Year',
          field: "year",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager',
          field: "manager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Gmp Lead',
          field: "gmpLead",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Change Date',
          field: "changeDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price',
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Description',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Supplier Item No',
          field: "supplierNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective From',
          field: "effectiveFrom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective To',
          field: "effectiveTo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PIN',
          field: "pin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Alocation Quantity',
          field: "allocationQtyKg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Allocation Notes',
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Payment Term',
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Picasso Facility',
          field: "picassoFacility",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Error Details',
          field: "errorDetails",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          pinned: "right",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        }
      ]
      setHeaderItems(cepgHeader)
    }
  }, [pmSourceData?.packagingPriceMemo, pmSourceData?.agriPriceMemo, pmSourceData?.sisPriceMemo, pmSourceData?.cepgPriceMemo])

  const selectionColumnDef = useMemo(() => ({
      pinned: "left",
    }), []);

  const gridApiRef = useRef(null); // Reference to the grid API

  const onGridReady = (params) => {
    gridApiRef.current = params.api; // Store the grid API instance
  };

  const clearAllFilters = () => {
    if (gridApiRef.current) {
      gridApiRef.current.setFilterModel(null); // Clear all filters
      setDisableFilterBtn(true);
    }
  };

  const onFilterChanged = (params) => {
    if (gridApiRef.current) {
      const filterModel = gridApiRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
      setFilteredTotalColumn(Object.keys(filterModel).length);

      // Get the filtered and total row counts
      const filteredRowCount = params.api.getDisplayedRowCount();
      const totalRowCount = params.api.getModel().getRowCount();

      setFilteredTotalItems(filteredRowCount);

      // Call the postFilterChanged handler if provided
      if (props.postFilterChanged) {
        props.postFilterChanged(filteredRowCount, totalRowCount);
      }
    }
  };

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.runOutputSeqId}`;
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === ""
          ? "-"
          : value;
      },
    },
    onFilterChanged,
  };

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title={title}
      fullWidth={true}
      maxWidth="xl"
      content={
        <>
          <div
            style={{
              display: "flex",
              marginBottom: "20px",
              justifyContent: "flex-end",
            }}
          >
            <ButtonComponent
              maxWidth="150px"
              label="Clear All Filters"
              bgColor="black"
              color="white"
              disabled={disableFilterBtn}
              onClick={clearAllFilters}
            />
          </div>
          {loading ? <Loader /> :
          <DataTablePagination
            columns={headerItems}
            rows={
              pmSourceData?.packagingPriceMemo ||
              pmSourceData?.agriPriceMemo ||
              pmSourceData?.sisPriceMemo ||
              pmSourceData?.cepgPriceMemo || []
            }
            onPageSizeChanged={onPageSizeChanged}
            enableCheckbox={false}
            goToPage={goToPage}
            pageSize={pageSize}
            currentPage={currentPage}
            totalPages={totalPages}
            totalPageItems={filteredTotalItems}
            totalItemCurrentPage={totalItemCurrentPage}
            gridOptions={gridOptions}
            postFilterChanged={handlePostFilterChanged}
            onGridReady={onGridReady}
            selectionColumnDef={selectionColumnDef}
            filteredTotalColumn={filteredTotalColumn}
          />}
        </>
      }
    />
  );
}
